import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/team2/SubTopic3/tooltipExtraTop3Act3.glb";
import { GUI } from "dat.gui";
import { gsap } from "gsap";
import ObserverEmitter, { EVENTS } from "../../../../../emitter/Observer";

export class TooltipExtraTop3Act3 extends Mesh {
	constructor(camera, loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		this.camera = camera;
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(1, 1, 1);
		this.observerListtneners();
		// this.helpers();
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			// gltf.scene.visible = false;
			this.add(gltf.scene);
			this.uncuartogeneral = gltf.scene.getObjectByName("uncuartogeneral", true);
			this.off = gltf.scene.getObjectByName("off", true);
			this.on = gltf.scene.getObjectByName("on", true);
			this.alarma = gltf.scene.getObjectByName("alarma", true);
			this.treslitros = gltf.scene.getObjectByName("treslitros", true);
			this.trescentigrados = gltf.scene.getObjectByName("trescentigrados", true);
		});
	}

	onvisibleObjects() {
		this.uncuartogeneral.visible = false;
		this.off.visible = false;
		this.on.visible = false;
		this.alarma.visible = false;
		this.treslitros.visible = false;
		this.trescentigrados.visible = false;
		// this.helpersChild();
	}

	onEliminateScene() {
		if (this.animation) {
			this.animation.kill();
		}
		this.visible = false;
	}

	observerListtneners() {
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.visibleunCuartoAct3, () => {
			this.uncuartogeneral.position.set(-0.8529, -0.4784, 0.4704);
			this.uncuartogeneral.rotation.y = -0.6543;
			this.uncuartogeneral.visible = true;
		});
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.hiddenunCuartoAct3, () => {
			this.uncuartogeneral.position.set(0, 0, 0);
			this.uncuartogeneral.rotation.set(0, 0, 0);
			this.uncuartogeneral.visible = false;
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFour.visibleunCuartoAct4, () => {
			this.uncuartogeneral.position.set(-2.3651, -0.8529, -0.4118);
			this.uncuartogeneral.rotation.y = 1.3307;
			this.uncuartogeneral.visible = true;
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFour.hiddenunCuartoAct4, () => {
			this.uncuartogeneral.position.set(0, 0, 0);
			this.uncuartogeneral.rotation.set(0, 0, 0);
			this.uncuartogeneral.visible = false;
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFive.tooltip.on, () => {
			this.on.position.set(-3.2843, -0.9597, 3.0306);
			this.on.rotation.y = 1.5512;
			this.on.visible = true;
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFive.tooltip.hiddenon, () => {
			this.on.visible = false;
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFive.tooltip.alert, () => {
			this.alarma.position.set(-3.2843, -0.9597, 3.0306);
			this.alarma.rotation.y = 1.5512;
			this.alarma.visible = true;
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFive.tooltip.hiddenalert, () => {
			this.alarma.visible = false;
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFive.tooltip.degrees, () => {
			this.trescentigrados.position.set(-3.2233, -0.9624, 1.7937);
			this.trescentigrados.rotation.y = 1.5512;
			this.trescentigrados.visible = true;
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFive.tooltip.hiddendegrees, () => {
			this.trescentigrados.visible = false;
		});
	}

	onAnimate(object, previousObject) {
		if (this.animation) {
			this.animation.kill();
		}

		//*regresar el color al anterior
		this.beforeColor = object.material.emissive;
		if (previousObject !== undefined) {
			if (this[previousObject] !== undefined) {
				this[previousObject].material.emissive = this.beforeColor;
			}
		}

		const newMaterial = object.material.clone();
		object.material = newMaterial;

		object.material.emissive.set("#404040");

		this.animation = gsap.to(object.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("Tooltip");
		premiaFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
	}

	helpersChild() {
		// this.helperMethod("trescentigrados", this.trescentigrados);
	}

	helperMethod(name, object) {
		const { position, rotation } = object;
		const gui = new GUI();
		const folferMostrador = gui.addFolder(name);
		folferMostrador.add(position, "x", -20, 20).step(0.0001).name("Posición X");
		folferMostrador.add(position, "y", -20, 20).step(0.0001).name("Posición Y");
		folferMostrador.add(position, "z", -20, 20).step(0.0001).name("Posición Z");
		folferMostrador.add(rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folferMostrador.add(rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folferMostrador.add(rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folferMostrador.add(object, "visible").name("Visible");
	}

	renderAnimations() { }
}
